import * as React from "react";
var ErrorHolder = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: 'alert-error' }, children));
};
export { ErrorHolder };
